import React, { useEffect, useState } from "react";
import { confirmClientPayment, getClientRequestList } from "../../services/admin-services/clientServices";
import Heading from "../../component/Heading/Heading";
import CommonButton from "../../component/button/Button";
import TableComponent from "../../component/Table/TableComponent";
import moment from "moment/moment";
import { TableCell, TableRow, Typography } from "@mui/material";
import Toast from "../../component/toastify/Index";
import { changeDateFormate } from "../../helper/changeDateFormate";
import "../../styles/pages/client/clientList.scss";
import { useTranslation } from "react-i18next";


const columns = [
  { field: "firstName", headerName: "First Name", translationKey: 'common_label_first_name' },
  { field: "lastName", headerName: "Last Name", translationKey: 'common_label_last_name' },
  { field: "email", headerName: "Email", translationKey: 'common_label_email' },
  { field: "company", headerName: "Company Name", translationKey: 'common_label_company_name' },
  { field: "mobileNumber", headerName: "Mobile Number", translationKey: 'common_label_mobile_number' },
  { field: 'referenceCode', headerName: 'Reference Code', translationKey: 'client_list_reference_code' },
  { field: "isPaymentConfirmation", headerName: "Payment Status", translationKey: 'approval_list_payment_status' },
  { field: "subscription", headerName: "Subscription", translationKey: 'client_list_subscription' },
  { field: "requestDate", headerName: "Request Date", translationKey: 'approval_list_request_date' },
  { field: "isApproved", headerName: "", translationKey: 'approval_list_request_date' },
];

const ClientRequestList = () => {
  const { t } = useTranslation();
  const [client, setClient] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchClients = async () => {
    const response = await getClientRequestList({ pageNo, perPage });
    if (response.isSuccess) {
      const formattedData = response?.clientRequestList?.map(
        (x) => {
          return {
            ...x,
            subscription: x.billingDetails?.planFrequency ?? "-",
            requestDate: x.billingDetails?.createdAt
              ? moment(x.billingDetails.createdAt).format("L")
              : "-",
          };
        }
      );
      setClient(formattedData);
      setTotalRecords(response?.totalRecords ? response?.totalRecords : 0);
    }
  };

  useEffect(() => {
    fetchClients();
  }, [pageNo, perPage]);


  const handleApprove = async (id) => {
    const response = await confirmClientPayment(id);
    if (response?.isSuccess) {
      Toast(response?.message, "success");
      fetchClients();
    }
  }

  return (
    <div className="users">
      <div className="user-heading flex items-center justify-between">
        <Heading text={t('approval_list_client_request_list')} className="user-heading" />
      </div>
      <div>
        <TableComponent
          columns={columns}
          setPageNo={setPageNo}
          pageNo={pageNo}
          perPage={perPage}
          setPerPage={setPerPage}
          totalRecords={totalRecords}
          className={'client-table-max-height'}
        >
          {client?.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              <TableCell >{row.clientRequest?.firstName}</TableCell>
              <TableCell >{row.clientRequest?.lastName}</TableCell>
              <TableCell >{row.clientRequest?.email}</TableCell>
              <TableCell > {row?.name || "N/A"} </TableCell>
              <TableCell >{row.clientRequest?.mobileNumber}</TableCell>
              <TableCell>{row.clientRequest?.referenceCode}</TableCell>
              <TableCell >{row.isFreeTrailPurchased && row.billingDetail?.planFrequency === "Free Trial" || (!row.isPaymentConfirmed && !row.billingDetail?.planFrequency) ? "-" : row.isPaymentConfirmed ? "Yes" : "No"} </TableCell>
              <TableCell >{row.billingDetail?.planFrequency ? row.billingDetail?.planFrequency : "-"}</TableCell>
              <TableCell >{row.billingDetail?.createdAt ? changeDateFormate(row.billingDetail?.createdAt) : "-"}</TableCell>
              <TableCell className='client-paymnet-confirm-btn'>
                <Typography sx={{ display: "flex", alignItems: "centere", gap: 2 }} >
                  <CommonButton
                    text={t('approval_list_approve')}
                    className="add-user-btn"
                    onClick={() => handleApprove(row.billingDetail._id)}
                  />
                  <CommonButton
                    text={t('approval_list_decline')}
                    className="add-user-btn"
                    bgColor="linear-gradient(90deg, #E14A4A 0%, #FF4848 100%)"
                  />
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableComponent>
      </div>
    </div>
  );
};
export default ClientRequestList;
